import React from "react";
import {
  Button,
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Input,
  Row,
  Table,
} from "reactstrap";
import PublicNavbar from "../../components/Navbars/PublicNavbar";
import AdminNavbar from "../../components/Navbars/AdminNavbar";
import AuthFooter from "../../components/Footers/AuthFooter";
import { useSelector } from "react-redux";

const TermsOfServicePage = () => {
  const userCredential = useSelector((state) => state?.userCredential);
  const isLoggedIn = userCredential && userCredential.token;

  return (
    <div className="vayco-admin public-protected">
      {/* //Protected Routes */}
      <div className="wrapper">
        <div className="main-panel">
          {isLoggedIn ? <AdminNavbar /> : <PublicNavbar />}
          <div className="content">
            <div className="mb-5"></div>
            <Container fluid className="mobilePadding-0">
              <Row className="justify-content-center" noGutters>
                <Col xl="6" lg="8" md="10">
                  <Card className="p-0 p-sm-3">
                    <CardHeader>
                      <CardTitle className="fs-26 text-theme fw-bold text-center">
                        Terms of Service
                      </CardTitle>
                    </CardHeader>
                    <CardBody>
                      <div className="blog-post-content">
                        <ol>
                          <li>
                            <h5>Welcome to NavigateHC.org</h5>
                            <p>
                              These Terms of Service (“Terms”) govern your use
                              of our website and services. By using this site,
                              you agree to these Terms. If you do not agree,
                              please do not use the site.
                            </p>
                          </li>

                          <li>
                            <h5>Purpose of This Site</h5>
                            <p>
                              NavigateHC is a free community resource tool to
                              help users find local services and, when
                              requested, connect with a community navigator. We
                              do not provide medical, legal, or professional
                              advice—only referrals and general information.
                            </p>
                          </li>

                          <li>
                            <h5>Use of the Site</h5>
                            <p>
                              You agree to use NavigateHC.org only for lawful
                              purposes and in a way that does not infringe on
                              the rights of others or limit their ability to use
                              the site.
                            </p>
                            <p>You may not:</p>
                            <ul>
                              <li>
                                Attempt to interfere with or gain unauthorized
                                access to the website.
                              </li>
                              <li>
                                Use the site to distribute harmful or illegal
                                content.
                              </li>
                              <li>
                                Impersonate another person or submit false
                                information.
                              </li>
                            </ul>
                          </li>

                          <li>
                            <h5>Navigator Requests</h5>
                            <p>
                              If you request to be connected with a navigator,
                              you agree to provide truthful and relevant
                              information to help us assist you. While we do our
                              best to connect you with helpful resources, we do
                              not guarantee outcomes or results.
                            </p>
                          </li>

                          <li>
                            <h5>Third-Party Links</h5>
                            <p>
                              Our website may include links to third-party
                              sites. These are provided for convenience only. We
                              do not control or endorse their content or
                              practices and are not responsible for any
                              interactions you have with them.
                            </p>
                          </li>

                          <li>
                            <h5>Privacy</h5>
                            <p>
                              Your use of this site is also governed by our{" "}
                              <a href="/privacy-policy">Privacy Policy</a>,
                              which explains how we collect and use data.
                            </p>
                          </li>

                          <li>
                            <h5>Limitation of Liability</h5>
                            <p>
                              NavigateHC.org is provided “as is” without
                              warranties of any kind. We are not liable for any
                              harm, injury, or loss resulting from the use of
                              this site, including reliance on listed resources
                              or navigator assistance.
                            </p>
                          </li>

                          <li>
                            <h5>Changes to These Terms</h5>
                            <p>
                              We may update these Terms from time to time. When
                              we do, we’ll revise the “Effective Date” and post
                              the new version on the site. Continued use after
                              changes means you accept the new Terms.
                            </p>
                          </li>

                          <li>
                            <h5>Contact</h5>
                            <p>
                              If you have any questions about these Terms, reach
                              out to us at:
                            </p>
                            <p>
                              <strong>NavigateHC</strong> <br />
                              Email:{" "}
                              <a href="mailto:Monica.Greer@hamiltoncounty.in.gov">
                                Monica.Greer@hamiltoncounty.in.gov
                              </a>
                            </p>
                          </li>
                        </ol>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
          <AuthFooter />
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
